import type { GanttSingleView } from '../../gantt-view-manager.js';
import type { GanttLinkPort } from './link-port.js';

/**
 * Minimal in-view fallback when the upstream consumer doesn't register
 * a {@link GanttLinkPort}. Mutates the dependencies cell on the source
 * row via the property's `valueSet`, which is the offical (non-Y.js-
 * direct) API. Idempotent: duplicates are filtered.
 *
 * Consumers that need bidirectional / cross-doc behaviour are expected
 * to replace this with a port that calls `createInverseRelationUnified`.
 */
export class DefaultLinkPort implements GanttLinkPort {
  constructor(private readonly view: GanttSingleView) {}

  createLink(fromRowId: string, toRowId: string): void {
    const depsCol = this.view.dependenciesCol$.value;
    if (!depsCol) return;
    const property = this.view.propertyGetOrCreate(depsCol);
    const cell = property.cellGetOrCreate(fromRowId);
    const raw = cell.value$.value;
    const existing = Array.isArray(raw)
      ? raw.filter(v => typeof v === 'string')
      : [];
    if (existing.includes(toRowId)) return;
    property.valueSet(fromRowId, [...existing, toRowId] as unknown as never);
  }
}
